import { Quotation } from './components/Quotation';

export const StepThree = () => <Quotation />;
